

  
<div class="modal fade" id="deleteModal" data-bs-backdrop="static" data-bs-keyboard="false" 
tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
<div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="deleteModalLabel">Remove</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

        <div class="alert alert-danger" role="alert">
          Are you sure you want to remove?
            <br>
            <strong>"{{deleteObject ? deleteObject.name:''}}"</strong>
          </div>
        
      </div>
      <div class="modal-footer">
        <button type="button" id="deleteModalCloseBtn" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-danger" (click)="deleteConfirm()">Yes! Remove</button>
      </div>
    </div>
  </div>
</div>